import { useState } from "react";
export function useTheme() {
  const [theme, setTheme] = useState(() =>
    document.documentElement.dataset.theme === "light" ? "light" : "dark",
  );
  function toggle() {
    const next = theme === "dark" ? "light" : "dark";
    document.documentElement.dataset.theme = next;
    document
      .querySelector('meta[name="theme-color"]')
      ?.setAttribute("content", next === "dark" ? "#191d1c" : "#f5f2e9");
    setTheme(next);
    try {
      localStorage.setItem("fj-theme", next);
    } catch {
      /* Theme remains usable when storage is unavailable. */
    }
  }
  return { theme, toggle };
}
